module.exports = __webpack_public_path__ + "build/img/spring2.c2180965.png";